var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStacksWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Stacks") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02.-Landing-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing-Desktop",
    transform: "translate(-1559.000000, -5923.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Site-Footer",
    transform: "translate(0.000000, 5786.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social",
    transform: "translate(1391.000000, 137.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacks",
    transform: "translate(168.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0019,8.92045184 L16.0019,10.8549778 L11.1247442,10.8549778 L14.5239449,16.00038 L11.9846046,16.00038 L7.99421384,9.9548764 L4.00382308,16.00038 L1.4779231,16.00038 L4.87713982,10.8684181 L0,10.8684181 L0,8.92045184 L16.0019,8.92045184 Z M3.96351812,0 L7.99421384,6.12608948 L12.0383659,0 L14.5777062,0 L11.2187464,5.07820859 L16.0019,5.07820859 L16.0019,7.03963117 L0,7.03963117 L0,5.07820859 L4.78308958,5.07820859 L1.42417782,0 L3.96351812,0 Z",
    id: "Combined-Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStacksWhite);
export default __webpack_public_path__ + "static/media/stacks-white.fd5da55e8a301a883775e9a1994298de.svg";
export { ForwardRef as ReactComponent };